import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-device-cap-modal',
  templateUrl: './device-cap-modal.component.html',
  styleUrls: ['./device-cap-modal.component.scss'],
})
export class DeviceCapModalComponent implements OnInit {

  deviceCapControl = new FormControl(0, [Validators.required, Validators.min(0)]);
  reasonControl = new FormControl('', [Validators.required]);
  uniqueDeviceCap: boolean = false;
  originalCap: number;
  monthlyCapping: boolean = true;

  constructor(
        private dialogRef: MatDialogRef<DeviceCapModalComponent>,
        @Inject(MAT_DIALOG_DATA) data: {uniqueDeviceCap: boolean, capValue: number, monthlyCapping: boolean},
		private params: ActivatedRoute
    ) {
        this.uniqueDeviceCap = data["uniqueDeviceCap"] ?? false;
        this.originalCap = (data["capValue"] ?? 0) / 1_000_000;
        this.deviceCapControl.setValue(this.originalCap);
        this.monthlyCapping = data["monthlyCapping"] ?? true;
    }

  ngOnInit() {
    // console.log(this.params);
    // if(this.params != null){
    //   this.uniqueDeviceCap = this.params.data["uniqueDeviceCap"] ?? false;
    //   this.originalCap = (this.params.data["capValue"] ?? 0) / 1_000_000;
    //   this.deviceCapControl.setValue(this.originalCap);
    // }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    if(this.uniqueDeviceCap && this.deviceCapControl.errors != null){
      this.deviceCapControl.markAsTouched();
      return;
    }
    if(this.reasonControl.errors != null){
        this.reasonControl.markAsTouched();
        return;
    }
    this.dialogRef.close({
        uniqueDeviceCap: this.uniqueDeviceCap,
        capValue: this.deviceCapControl.value * 1_000_000,
        monthlyCapping: this.monthlyCapping,
        reason: this.reasonControl.value
    });
  }

}